import { QueryParams } from '../constants';
import { getLoginMethod } from './getLoginMethod';

export const getPlatform = (
  locationSearch = window.location.search
) => {
  const defaultPlatform = getLoginMethod();
  const urlParams = new URLSearchParams(locationSearch);
  const redirectDestination = urlParams.get(QueryParams.RedirectTo) || urlParams.get(QueryParams.RedirectToAlt);

  if (redirectDestination) {
    const urlCheckFuncs = [
      () => ['academy-qualifications.', 'academy.', '/online-training'].some(e => redirectDestination.includes(e)) ?
        'Protector Academy' : null,
      () => redirectDestination.includes('registration.') ? 'Events' : null,
      () => redirectDestination.includes('checkout.') ? 'Checkout' : null,
      () => redirectDestination.includes('/resources/ccw_reciprocity_map') ? 'Reciprocity' : null,
      () => redirectDestination.includes('deltadefense.com') ? 'Delta Defense' : null,
      () => redirectDestination.includes('my.') ? 'Member Site' : null,
      () => redirectDestination.includes('/blog') ? 'Blog' : null
    ];
    return urlCheckFuncs.find(u => !!u())?.() || defaultPlatform;
  } else {
    return defaultPlatform;
  }
};
